import React, { useMemo } from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import RedhatACSCredentialsForm from "./RedhatACSCredentialsForm";
import RedhatACSMappingForm from "./RedhatACSMappingForm";
import { columnRenderArrayData } from 'utils/tableUtils';
export default function RedhatACSConfigListing(props) {
  const columns = useMemo(
    () => [
      {
        title: "Cluster",
        dataIndex: "cluster",
        width: 240,
      },
      {
        title: "Namespace",
        dataIndex: "namespace",
        width: 240,
        render: columnRenderArrayData,
      },
      {
        title: "Deployments",
        dataIndex: "deploymentNames",
        width: 240,
        render: columnRenderArrayData,
      }
    ],
    []
  );
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={RedhatACSMappingForm}
      CredentialsForm={RedhatACSCredentialsForm}
      extraColumns={columns}
    />
  );
}
